import { CapoPlugin } from "/workd/WORKD/_LABS/nuxtTs/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];